import chainListSelector from './selector';

export default chainListSelector;
